/* AED Professionals — TCO Calculator logic.
   Loads from the theme so it does not depend on GemPages running inline scripts.
   Safe site-wide: it does nothing unless the .aedp-tco calculator markup is on the page.
   Pair this with the HTML + CSS (the <div class="aedp-tco">...</div> block) in GemPages.

   PRICES VERIFIED AGAINST THE LIVE SHOPIFY ADMIN API 2026-08-25.
   Every number in the AEDS array below mirrors a specific SKU. Do not edit a price
   without checking the SKU it is keyed to in Price_Drift_Registry.md — training
   consumables and ReCelled batteries carry near-identical titles at very different prices. */
(function(){
  var tries = 0;
  function boot(){
    var root = document.querySelector('.aedp-tco');
    if(!root || !root.querySelector('#aedpSelA')){
      if(tries++ < 200){ setTimeout(boot,60); }   /* wait up to ~12s for GemPages to inject, then stop */
      return;
    }
    if(root.getAttribute('data-aedp-ready')==='1'){ return; }
    root.setAttribute('data-aedp-ready','1');

    /* ====== EDIT THESE NUMBERS TO MATCH LIVE SHOPIFY PRICING ======
       SKU map (device / battery / adult pads / pediatric pads):
       zollplus     8000-004000-01 / 8000-0807-01   / 8900-0800-01   / 8900-0810-01
       zoll3        8511-001101-01 / 8000-000696    / 8900-000280-01 / universal, 0
       onsite       M5066A_C02     / M5070A (OEM)   / M5071A         / M5072A
       frx          861304_C01     / M5070A (OEM)   / 989803139261   / Infant/Child Key, 0
       lifeline     DCF-A100-EN    / DCF-210 (7yr)  / DDP-100        / DDP-200P
       lifelineview DCF-A2310EN    / DCF-2003       / DDP-2001       / DDP-2002
       g5           G5S-80C-S      / XBTAED001A     / XELAED001B     / XELAED003C
       hs350        350-STR-US-10  / PAD-PAK-01     / combined, 0    / PAD-PAK-02
       hs450        450-STR-US-10  / PAD-PAK-01     / combined, 0    / PAD-PAK-02
       cr2          99512-001262   / 11141-000165   / 11101-000021   / universal, 0
       Battery prices are OEM, never ReCelled: M5070A is 249, M5070A-ABE is 154. */
    var AEDS = [
      {id:"zollplus",brand:"ZOLL",name:"AED Plus",price:2082,warranty:7,batteryPrice:103,batteryLife:5,padPrice:237,padLife:5,pedPrice:131,pedLife:2,combined:false,handle:"zoll-aed-plus"},
      {id:"zoll3",brand:"ZOLL",name:"AED 3",price:2399,warranty:8,batteryPrice:207,batteryLife:5,padPrice:248,padLife:5,pedPrice:0,pedLife:5,combined:false,handle:"zoll-aed-3"},
      {id:"onsite",brand:"Philips",name:"HeartStart OnSite",price:1687,warranty:8,batteryPrice:249,batteryLife:4,padPrice:99,padLife:2,pedPrice:139,pedLife:2,combined:false,handle:"philips-heartstart-onsite-aed"},
      {id:"frx",brand:"Philips",name:"HeartStart FRx",price:2427,warranty:8,batteryPrice:249,batteryLife:4,padPrice:89,padLife:2,pedPrice:0,pedLife:2,combined:false,handle:"philips-heartstart-frx-aed"},
      {id:"lifeline",brand:"Defibtech",name:"Lifeline AED",price:1523,warranty:8,batteryPrice:275.73,batteryLife:7,padPrice:77.40,padLife:2,pedPrice:134.16,pedLife:2,combined:false,handle:"defibtech-lifeline-aed"},
      {id:"lifelineview",brand:"Defibtech",name:"Lifeline VIEW",price:2086,warranty:8,batteryPrice:247.66,batteryLife:4,padPrice:85.54,padLife:2,pedPrice:140.49,pedLife:2,combined:false,handle:"defibtech-lifeline-view-aed"},
      {id:"g5",brand:"Cardiac Science",name:"Powerheart G5",price:2157,warranty:8,batteryPrice:495,batteryLife:4,padPrice:88,padLife:2,pedPrice:127,pedLife:2,combined:false,handle:"cardiac-science-powerheart-g5-aed"},
      {id:"hs350",brand:"HeartSine",name:"Samaritan PAD 350P",price:1411,warranty:10,batteryPrice:236,batteryLife:4,padPrice:0,padLife:4,pedPrice:279,pedLife:4,combined:true,handle:"heartsine-samaritan-pad-350p-aed"},
      {id:"hs450",brand:"HeartSine",name:"Samaritan 450P",price:1761,warranty:10,batteryPrice:236,batteryLife:4,padPrice:0,padLife:4,pedPrice:279,pedLife:4,combined:true,handle:"heartsine-samaritan-450p-aed-with-cpr-rate-advisor"},
      {id:"cr2",brand:"Physio-Control / Stryker",name:"LIFEPAK CR2",price:2256,warranty:8,batteryPrice:327,batteryLife:4,padPrice:188,padLife:2,pedPrice:0,pedLife:2,combined:false,handle:"physio-control-lifepak-cr2-aed"}
    ];
    var STORE = "https://aedprofessionals.com/products/";
    var years = 10, includePed = false;

    function money(n){ return "$" + Math.round(n).toLocaleString("en-US"); }
    function reps(y,life){ return Math.max(0, Math.ceil(y/life) - 1); }

    function compute(a){
      var o = {purchase:a.price,battery:0,pads:0,ped:0};
      o.batteryReps = reps(years,a.batteryLife);
      o.battery = o.batteryReps * a.batteryPrice;
      if(!a.combined){ o.padReps = reps(years,a.padLife); o.pads = o.padReps * a.padPrice; }
      if(includePed && a.pedPrice > 0){ o.ped = (reps(years,a.pedLife)+1) * a.pedPrice; }
      o.total = o.purchase + o.battery + o.pads + o.ped;
      return o;
    }
    function specRow(k,v,sub){ return '<div class="aedp-spec"><span class="aedp-k">'+k+'</span><span class="aedp-v">'+v+(sub?'<small>'+sub+'</small>':'')+'</span></div>'; }

    function renderCard(el,a,c,win){
      var consumable = a.combined
        ? specRow("Pad-Pak (battery + pads)", money(a.batteryPrice), "Replace every "+a.batteryLife+" yrs \u00b7 combined")
        : specRow("Replacement Battery", money(a.batteryPrice), "Shelf life "+a.batteryLife+" yrs") + specRow("Adult Pads", money(a.padPrice), "Shelf life "+a.padLife+" yrs");
      var ped = includePed ? (a.pedPrice>0 ? specRow("Pediatric Pads", money(a.pedPrice), "Shelf life "+a.pedLife+" yrs") : specRow("Pediatric Coverage","Built in","Universal pads / child mode")) : "";
      el.className = "aedp-mcard" + (win ? " aedp-win" : "");
      el.innerHTML =
        '<div class="aedp-mhead">'+(win?'<span class="aedp-flag">Lower '+years+'-Yr Cost</span>':'')+'<span class="aedp-btag">'+a.brand+'</span><h3>'+a.name+'</h3></div>'+
        '<div class="aedp-specs">'+specRow("Purchase Price",money(a.price))+specRow("Warranty",a.warranty+" years")+consumable+ped+'</div>'+
        '<div class="aedp-tcobox"><div class="aedp-tcolabel">Estimated '+years+'-Year Total Cost</div><div class="aedp-tconum">'+money(c.total)+'</div>'+
        '<div class="aedp-tcosub">'+money(a.price)+' unit + '+money(c.total-a.price)+' consumables over '+years+' yrs</div></div>'+
        '<a class="aedp-cta" href="'+STORE+a.handle+'" target="_blank" rel="noopener">View '+a.brand+' '+a.name+' \u2192</a>';
    }
    function renderBars(a,ca,b,cb){
      var max = Math.max(ca.total,cb.total) || 1;
      function seg(val,cls){ var p=(val/max)*100; return p>0?'<div class="'+cls+'" style="width:'+p+'%"></div>':''; }
      function rowHtml(m,c){
        return '<div class="aedp-bar"><div class="aedp-bartop"><span>'+m.brand+' '+m.name+'</span><span>'+money(c.total)+'</span></div>'+
          '<div class="aedp-track2"><div class="aedp-stack" style="width:'+((c.total/max)*100)+'%">'+seg(c.purchase,"aedp-sp")+seg(c.battery,"aedp-sb")+seg(c.pads,"aedp-spd")+seg(c.ped,"aedp-spd")+'</div></div></div>';
      }
      root.querySelector("#aedpBars").innerHTML = rowHtml(a,ca)+rowHtml(b,cb);
    }
    function renderSavings(a,ca,b,cb){
      var el = root.querySelector("#aedpSavings"); var diff = Math.abs(ca.total-cb.total);
      if(diff===0){ el.innerHTML='<div class="aedp-big">It\'s a <em>tie</em>.</div><div class="aedp-stxt">Both units land at the same estimated '+years+'-year total. Compare warranty, ease of use, and pad shelf life \u2014 or call 888-541-2337.</div>'; return; }
      var cheaper = ca.total < cb.total ? a : b;
      el.innerHTML='<div class="aedp-big">Save <em>'+money(diff)+'</em></div><div class="aedp-stxt">Over '+years+' years, the <strong>'+cheaper.brand+' '+cheaper.name+'</strong> is the lower-cost choice by '+money(diff)+' once batteries and pads are counted \u2014 not just the day-one price.</div>';
    }
    function render(){
      var selA = root.querySelector("#aedpSelA"), selB = root.querySelector("#aedpSelB");
      var a = AEDS.filter(function(x){return x.id===selA.value;})[0];
      var b = AEDS.filter(function(x){return x.id===selB.value;})[0];
      var ca = compute(a), cb = compute(b);
      renderCard(root.querySelector("#aedpCardA"),a,ca,ca.total<cb.total);
      renderCard(root.querySelector("#aedpCardB"),b,cb,cb.total<ca.total);
      renderSavings(a,ca,b,cb); renderBars(a,ca,b,cb);
      root.querySelector("#aedpVizYears").textContent = years;
    }

    var selA = root.querySelector("#aedpSelA"), selB = root.querySelector("#aedpSelB");
    AEDS.forEach(function(a){
      var label = a.brand+" "+a.name;
      selA.add(new Option(label,a.id)); selB.add(new Option(label,a.id));
    });
    selA.value = "zollplus"; selB.value = "onsite";
    selA.addEventListener("change",render);
    selB.addEventListener("change",render);
    root.querySelector("#aedpPed").addEventListener("change",function(e){ includePed = e.target.checked; render(); });
    root.querySelectorAll("#aedpYearSeg button").forEach(function(btn){
      btn.addEventListener("click",function(){
        root.querySelectorAll("#aedpYearSeg button").forEach(function(x){ x.classList.remove("aedp-active"); });
        btn.classList.add("aedp-active"); years = parseInt(btn.dataset.yrs,10); render();
      });
    });
    render();
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
})();